<template>
  <div class="h-100">
    <nav class="navbar headPage is-flex is-align-center is-fixed-top">
      <div class="container">
        <div class="columns is-align-center w-100 ">
          <div class="column is-6 has-text-white is-size-3 is-size-4-mobile is-flex is-justify-between is-align-center">
            <router-link :to="user =='' ? '/' : '/profile'" class="has-text-white mg-l-3">
              <span class=" has-text-weight-semibold">Great</span>Growth
            </router-link>
            <div class="is-hidden-tablet is-size-5" @click="menuMobile = !menuMobile">
              <p v-if="user !=''" class="has-text-white cursor th text-capitalize"  slot="trigger"
                  role="button">
                {{user.detailUser[0].name}}&nbsp;&nbsp;<i class="fas fa-bars"></i>
              </p> 
              <span v-else>
                <i  class="fas fa-bars"></i>
              </span>
              
            </div>
          </div>
          <div class="column is-paddingless is-hidden-mobile">
            <div v-if="user != '' && user != null" class="is-flex is-align-center is-justify-end">
              <a @click="checkisuserReview()" class="has-text-white mg-x-3">Write a review</a>
                <a @click="checkisuserticket()" class="has-text-white mg-x-3">Ticket</a>
                <div class="profilePic mg-x-3">
                  <img v-if="typeof user.detailUser[0] != 'undefined' && user.detailUser[0].profilePic" :src="imgPath + user.detailUser[0].profilePic">
                  <img v-else src="@/assets/user.png">
                </div>
                <div class="mg-5px"> 
                  <b-dropdown aria-role="list" position="is-bottom-left">
                    <p v-if="typeof user.detailUser[0] != 'undefined'" class="has-text-white cursor th text-capitalize"  slot="trigger"
                  role="button">
                        {{user.detailUser[0].name}}&nbsp;&nbsp;<i class="fas fa-chevron-down"></i>
                    </p>
                    <b-dropdown-item aria-role="listitem" class="has-text-dark" :href="user.userLevel == 50 ? '/form/edit' : '/edit-profile'">
                      Edit Profile
                    </b-dropdown-item>
                    <b-dropdown-item @click="signout()" aria-role="listitem">Sign out</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <div v-else class="has-text-right ">
                <router-link class="has-text-white mg-x-5" to="/signin">SIGN IN</router-link> 
                <router-link  class="has-text-white" to="/signup/company">SIGN UP</router-link> 
              </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="bodyPage container">
      <div class="page-box">
        <slot></slot>
      </div>
    </div>
    <div id="navbarBasicExample" class="slide-menu is-hidden-tablet"  :class="menuMobile ? 'active':''"  >
        <div class="left-close-menu" @click="menuMobile = false">
          
        </div>
        <div class="navbar-end inside-menu has-text-white">
          <ul>
            <li class="has-text-white is-size-5 mg-t-20 is-flex" v-if="user != ''">
                <div class="profilePic mg-x-3">
                  <img v-if="typeof user.detailUser[0] != 'undefined' && user.detailUser[0].profilePic" :src="imgPath + user.detailUser[0].profilePic">
                  <img v-else src="@/assets/user.png">
                </div>
                <p v-if="typeof user.detailUser[0] != 'undefined'" class="has-text-white cursor th is-flex is-align-center"  slot="trigger"
                  role="button">
                        {{user.detailUser[0].name}}
                    </p> 
                <a @click="menuMobile = false" class="has-text-white is-size-6 close-menu"><i class="fas fa-times"></i></a>
            </li>
             <li class="has-text-white is-size-5 mg-t-20 " v-else>
                <span class="has-text-weight-bold">Great</span><span style="font-weight: initial !important;"> Growth  </span> 
                <a @click="menuMobile = false" class="has-text-white is-size-6 close-menu"><i class="fas fa-times"></i></a>
            </li>
            <span v-if="user != '' && user != null">
              <li>
                <router-link class="has-text-white" :to="user.userLevel == 50 ? '/form/edit' : '/edit-profile'">
                  <i class="fas fa-edit"></i> Edit Profile
                </router-link>
              </li>
              <li>
                <a class="has-text-white" @click="signout()">
                  <i class="fas fa-sign-out-alt"></i> Sign out
                </a>
              </li>
            </span>
            <span v-else>
              <li>
                <router-link class="has-text-white" to="/signin">SIGN IN</router-link> 
              </li>
              <li>
                <router-link class="has-text-white" to="/signup/company">SIGN UP</router-link> 
              </li>
            </span>
             
          </ul>
        </div>
      </div>
  </div>
</template>
<script>
  export default {

    methods:{
      signout(){
       setTimeout(() => {
            window.localStorage.clear();
          }, 100);
          this.$store.commit("clearlogin");
          window.localStorage.removeItem("vuex");
          this.$router.push("/signin");
      },
      checkisuserticket(){
        let text = JSON.stringify(this.user.detailUser[0])
        let obj = JSON.parse(text)
        obj['userLevel'] = this.user.userLevel
        obj['typeSystem'] = this.user.typeSystem
        obj['userIdExport'] = this.user.typeSystem == 'inteGreat' ? this.user.detailUser[0].userIdExport : this.user.userId
        obj['projectCode'] = 'oZcIppU-VBIx9KO'
        console.log('obj',obj)
        var jwt = require('jsonwebtoken');
        var secret = 'dFvsdd125ssE'
        var token = jwt.sign({ 
          token:this.user.token,
          obj:obj
         }, secret);
        window.open(this.urlTicket+'token/'+token, '_blank');
        //window.open('http://localhost:8080/token/'+token, '_blank');
      },
      checkisuserReview(){
        let text = JSON.stringify(this.user)
        let input = JSON.parse(text)
        console.log('input',input)
        let obj ={
          businessData: input.businessData,
          detailUser: input.detailUser[0],
          email: input.detailUser[0].email,
          name: input.detailUser[0].name,
          objectTelephoneNumber: input.detailUser[0].objectTelephoneNumber,
          profilePic: input.detailUser[0].profilePic,
          surname: input.detailUser[0].surname,
          token: input.token,
          typeSystem: input.typeSystem,
          typeSystemId: '',
          uid: "",
          userExport: input.userId,
          userId: input.userId,
          userLevel: input.userLevel
        }

        console.log('obj',obj)
        var jwt = require('jsonwebtoken');
        var secret = 'dFvsdd125ssE'
        var token = jwt.sign({ 
          token:this.user.token,
          obj:obj
         }, secret);
        window.open(this.urlReview+'token/'+token, '_blank');
        //window.open('http://localhost:8080/token/'+token, '_blank');
      },
    },
    data(){
      return{
        urlTicket:process.env.VUE_APP_BASEURL_TICKET,
        urlReview:process.env.VUE_APP_BASEURL_LINK_REVIEW,
        imgPath:'',
         menuMobile:false
      }
    },
    created(){
      this.imgPath = this.user.typeSystem == 'mentor' ? process.env.VUE_APP_IMG_PROFILE : process.env.VUE_APP_IMG_PROFILE_INTEGREAT
    },
    computed:{
      viewprofile(){
        return this.$store.state.viewprofile
      },
      user(){
        return this.$store.state.islogin
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inside-menu{
  background: #0D6ACA;
  width: 70%;
  height: 100%;
  float: right;
}
.left-close-menu{
  width: 30%;
  height: 100%;
  float: left;
}
.close-menu{
  position: absolute;
  right: 5%;
  top: 2%;
}
.inside-menu li {
  border-bottom:1px solid #fff;
  padding:15px;
}
.slide-menu.active{
  right: 0;
}
.slide-menu{
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    right: -100%;
    background:rgba(0,0,0,0.6);
    z-index: 800;
    transition:all .4s;
    --webkit-transition: all 0.4s;
}
  .profilePic{
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .scrollPage{
    /* overflow-y:scroll; */
    overflow-x: hidden;
    height: 100%;
  }
  .bodyPage{
    margin-top: 80px;
  }
  .page-box{
    height: 100%;
    background: #fff;
    border-radius: 7px;
    margin:2% 0;
    overflow-x:unset;
  }
  .page-main{
    padding: 20px;
    min-height: 400px;
  }
  .headPage{
    background: #0D6ACA;
    padding:5px 0;
    height: 80px;
    z-index: 100!important;
  }
  .footerPage{
    display: flex;
    align-items: center;
    justify-content: center;
    padding:5px 0;

  }
</style>
